module.exports = __webpack_public_path__ + "static/img/logo08.5a68fdbc.png";